import { alpha } from "@mui/material/styles";

// The surface behind a page title or a selected menu entry. In light mode it
// is the solid brand colour with white text. In dark mode a solid block of the
// brand colour glares, so it is the selected look of the side rail: a dark
// surface with a wash of the brand colour, a bar on the left and brand text.
export const accentSurface = (theme) => {
  const brand = theme.palette.primary.light;
  if (theme.palette.mode !== "dark") {
    return { backgroundColor: brand, color: "#fff" };
  }
  const wash = alpha(brand, 0.12);
  return {
    // Opaque, so content scrolling underneath does not show through.
    backgroundColor: theme.palette.background.paper,
    backgroundImage: `linear-gradient(${wash}, ${wash})`,
    boxShadow: `inset 3px 0 0 ${brand}`,
    color: brand,
  };
};

// Text on that surface.
export const accentSurfaceText = (theme) =>
  theme.palette.mode === "dark" ? theme.palette.primary.light : "#fff";
